import { ImportMetaEnv, ModeType } from '../util';

export const MODE: ModeType = (import.meta as anyOk).env.MODE as ModeType;

export const TYPE = 'vite';

export const ENV_VARS = (import.meta as anyOk).env as unknown as ImportMetaEnv;
